import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  makeStyles,
  Checkbox,
  DialogContent,
  DialogContentText,
  FormControlLabel,
} from '@material-ui/core';

import ConfirmationDialog from 'components/ConfirmationDialog';

const useStyles = makeStyles((theme) => {
  return {
    /* Styles applied to the root element. */
    root: {},
    dialogActions: {
      margin: theme.spacing(2),
      marginTop: theme.spacing(0),
    },
    formControl: {
      marginLeft: theme.spacing(0),

      ...theme.typography.body1,
      color: theme.palette.greyBlue[700],
    },
    title: {
      ...theme.typography.h6,
      color: theme.palette.greyBlue[700],
    },
    textContent: {
      ...theme.typography.body1,
      color: theme.palette.greyBlue[700],
    },
  };
});

const TTSDialog = ({
  className,
  handleClose,
  handleFitToScreen = () => {},
  handleLeaveAsIs = () => {},
  open,
  ...props
}) => {
  const classes = useStyles();

  const [isMessageChecked, setIsMessageChecked] = useState(false);
  const handleChange = () => {
    setIsMessageChecked((prev) => {
      return !prev;
    });
  };

  const onLeaveAsIs = () => {
    handleLeaveAsIs(isMessageChecked);
    handleClose();
  };

  const onFitToScreen = () => {
    handleFitToScreen(isMessageChecked);
    handleClose();
  };

  return (
    <div className={clsx(classes.root, className)} {...props}>
      <ConfirmationDialog
        cancel={{
          label: 'No, Leave As Is',
          action: onLeaveAsIs,
        }}
        confirm={{
          label: 'Yes, Fit To Screen',
          action: onFitToScreen,
        }}
        id={'confirmTtsZoomfitDialog'}
        isOpen={open}
        labelledById="tts-dialog"
        onClose={() => handleLeaveAsIs(isMessageChecked)}
        showTitle
        title="Text-to-Speech Recommendation"
        titleComponent="h2"
      >
        <DialogContent>
          <DialogContentText className={classes.textContent}>
            You are currently zoomed in. We recommend using Text-to-Speech when
            your appearance settings are set to “Fit to Screen.” Would you like
            to change your appearance settings to fit all the content in the
            screen?
          </DialogContentText>
          <FormControlLabel
            className={classes.formControl}
            control={
              <Checkbox
                checked={isMessageChecked}
                onChange={handleChange}
                name="showMessasge"
                color="primary"
              />
            }
            label="Save my preference"
          />
        </DialogContent>
      </ConfirmationDialog>
    </div>
  );
};

TTSDialog.propTypes = {
  /**
   * @ignore
   */
  className: PropTypes.string,
  handleClose: PropTypes.func,
  handleFitToScreen: PropTypes.func,
  handleLeaveAsIs: PropTypes.func,
  open: PropTypes.bool,
};

export default TTSDialog;
